<div class="container">

  <app-header-dialog [iconName]="'mail_outline'">
    Carta para Anuidades
  </app-header-dialog>


  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
          <div style='color:rgb(43,54,123)'>Texto</div>
        </ng-template>

        <div class='tab-content'>

          <mat-form-field class="title-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="title-width" appearance="outline">
            <mat-label>Título do e-mail</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.subject"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.subject.hasError('required')">
              O Assunto é obrigatório
            </mat-error>
          </mat-form-field>

          <ckeditor [editor]="Editor" [config]="{ 
                toolbar: [ 'heading', '|', 'undo', 'redo', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|' ]
               }" [formControl]="entityForm.controls.text"></ckeditor>
          <mat-error *ngIf="entityForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
          <div style='color:rgb(43,54,123)'>Imgem no email</div>
        </ng-template>

        <div class='tab-content-img'>

          <div style="width: 100%; text-align: center;">
            <p>Esta imagem irá aparecer no topo do email enviado. </p>
            <p>O tamanho ideal desta imagem é de 200 x 600 pixels</p>
          </div>

          <div class='img-input'>
            <input #file type="file" accept='image/*' style='display:none' (change)="previewImage($event)" />
          </div>
          <div class="post-image">
            <img [src]="storedImage" *ngIf="storedImage">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>
        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button matTooltip='Insert' mat-raised-button (click)="matDialogRef.close(['insert',entityForm, objectImage])"
      [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button matTooltip='Update' mat-raised-button (click)="matDialogRef.close(['update',entityForm, objectImage])"
      [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>